export const CIRCLE = 'circle';
export const DEFAULT = 'default';
